import React, { useContext } from "react";
import { UserContext, PatientContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import SadSallie from "../../images/sallie-oops.png";
import SallieTail from "../../images/sallie-tail.gif";
import SallieBlink from "../../images/sallie-blink.gif";
import SallieWave from "../../images/sallie-wave.gif";

const sallieVariants = {
  default: { src: SallieTail, alt: "Sallie wagging her tail" },
  sad: { src: SadSallie, alt: "Sad Sallie" },
  face: { src: SallieBlink, alt: "Sallie close up of face" },
  wave: { src: SallieWave, alt: "Sallie waving" },
};

const Sallie = ({ text, variant = "default", isTPCG, isProvider }) => {
  const { user } = useContext(UserContext);
  const { patient } = useContext(PatientContext);
  const { t } = useTranslation();

  const { src: imgSrc, alt: imgAlt } =
    sallieVariants[variant] || sallieVariants.default;

  return (
    <div className="flex flex-col gap-2 items-center md:flex-row md:gap-6">
      <img className="w-48 h-auto md:w-24" src={imgSrc} alt={imgAlt} />
      <div className="sallie">
        <h6 className="m-1">{text}</h6>
      </div>

      {user?.noPatientProvider !== "noPatient" && (isProvider || isTPCG) && (
        <h6 className="flex flex-col gap-1">
          {isProvider
            ? t("sallie.patient_info.provider")
            : t("sallie.patient_info.non_provider")}

          <span className="text-3xl">
            {patient?.firstName} {patient?.lastName}
          </span>

          {patient?.externalId && `ID: ${patient.externalId}`}
        </h6>
      )}
    </div>
  );
};

export default Sallie;